import React, { useEffect, useState } from "react";
import {
  SearchContainer,
  SearchInput,
  SearchIcon,
  CleanSearchIcon,
  Pagination,
  Grid,
  Column,
} from "./styles";
import { Select } from "semantic-ui-react";

const Controls = (props) => {
  // const cursosOptions = [{ key: "1", value: "wcm", text: "WCM" }];

  const currentYear = new Date().getFullYear();

  const startYear = 2017;
  const years = Array(currentYear - startYear + 1)
    .fill(null)
    .map((v, index) => startYear + index);

  const yearsOptions = years.map((year, index) => ({
    key: index,
    value: year,
    text: year,
  }));

  const intensOptions = [
    { key: "0", value: 0, text: "Todos" },
    { key: "1", value: 1, text: "Materiais" },
    { key: "2", value: 2, text: "Certificados" },
    { key: "3", value: 3, text: "Ambos" },
  ];

  const statusOptions = [
    { key: "1", value: "", text: "Todos" },
    { key: "2", value: "Pago", text: "Pago" },
    { key: "3", value: "Não Pago", text: "Não Pago" },
  ];

  const handleItemChange = (e, { value }) => {
    props.setItem(value);
  };

  const handleYearChange = (e, { value }) => {
    props.setYear(value);
  };

  const handleStatusChange = (e, { value }) => {
    props.setStatus(value);
  };

  const handleSearchInputChange = (e, { value }) => {
    props.setSearch(value);
  };

  return (
    <Grid columns={4}>
      <Column>
        <SearchContainer>
          <SearchInput
            fluid
            placeholder="Nome ou email"
            onChange={handleSearchInputChange}
          />

          {props.search ? (
            <SearchIcon size={22} onClick={props.doSearches} />
          ) : (
            <CleanSearchIcon size={22} onClick={props.cleanSearches} />
          )}
        </SearchContainer>
      </Column>
      <Column>
        <Pagination
          page={props.page}
          onChange={props.handleChange}
          count={props.pages}
          shape="rounded"
        />
      </Column>
      <Column>
        <Select
          onChange={handleYearChange}
          placeholder="Ano"
          value={props.year}
          options={yearsOptions}
        />
      </Column>
      <Column>
        <Select
          onChange={handleItemChange}
          placeholder="Itens"
          value={props.item}
          options={intensOptions}
        />
      </Column>
      <Column>
        <Select
          onChange={handleStatusChange}
          placeholder="Status"
          value={props.status}
          options={statusOptions}
        />
      </Column>
    </Grid>
  );
};

export default Controls;
